import type {SessionUser} from "../../shared/auth/access";
export const roleLabels: Record<SessionUser["role"], string> = {
  PLANLAMA: "Planlama",
  SATIN_ALMA: "Satın Alma",
  SATIN_ALMA_MUDURU: "Satın Alma Müdürü",
  GENEL_MUDUR: "Genel Müdür",
  KALITE_UZMANI: "Kalite Uzmanı",
  KALITE_MUDURU: "Kalite Müdürü",
  URETIM_OPERATORU: "Üretim Operatörü",
  VARDIYA_AMIRI: "Vardiya Amiri",
  URETIM_YONETICISI: "Üretim Yöneticisi",
  TEKNIK_MUDURU: "Teknik Departman Müdürü",
  DEPO_GOREVLISI: "Depo Görevlisi",
  CEP_DEPO_SORUMLUSU: "Cep Depo Sorumlusu",
  SISTEM_YONETICISI: "Sistem Yöneticisi",
  GUEST: "Yetkisiz",
};

export function formatDate(value: string) {
  return new Intl.DateTimeFormat("tr-TR", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function deviceLabel(userAgent: string | null) {
  if (!userAgent) return "Bilinmeyen cihaz";
  if (userAgent.includes("Macintosh")) return "Mac · Web tarayıcısı";
  if (userAgent.includes("Windows")) return "Windows · Web tarayıcısı";
  if (userAgent.includes("iPhone")) return "iPhone · Mobil tarayıcı";
  if (userAgent.includes("Android")) return "Android · Mobil tarayıcı";
  return "Web tarayıcısı";
}
